import axios from 'axios';

export default {
  documentServiceClient(state, getters, rootState) {
    if (!state.documentServiceClient) {
      state.documentServiceClient = axios.create({
        baseURL: `${payload.services.documentservice.url}/api/v2/document`
      });

      if (rootState.user.activeUser) {
        state.documentServiceClient.defaults.headers.common.Authorization = `Bearer ${rootState.user.activeUser.token}`;
      }
    }

    return state.documentServiceClient;
  },
  nonImageAssets(state) {
    if (!state.pigment.assets
        || !Array.isArray(state.pigment.assets)) {
      return [];
    }

    return state.pigment.assets
      .filter((asset) => !['image_color_chip'].includes(asset.type)
            && (!state.fieldManifest[asset.type] || state.fieldManifest[asset.type].availableInSearch === true))
      .map((asset) => {
        asset.label = null;
        if (state.fieldManifest.hasOwnProperty(asset.type)) {
          asset.label = state.fieldManifest[asset.type].title;
        }

        return asset;
      })
      .sort((left, right) => (left.type <= right.type ? -1 : 1));
  }
};
